<img [src]="path" alt="reddi logo" class="reddi-logo" />
